export const FAX_ACTION = {
  inbound: "VIEW_INBOUND_FAX",
  outbound: "VIEW_OUTBOUND_FAX",
  download: "DOWNLOAD_FAX",
  forward: "FORWARD_TO_FAX",
  compose: "COMPOSE_FAX",
  delete: "DELETE_FAX",
  cancel: "CANCEL_FAX",
}

export const AUTH_EMAIL_APP_USER_REGISTRATION = "marie.gooneratne@consensus.com"

export const USER_ROLES = [
  { value: "ADMIN", label: "ADMIN" },
  { value: "USER", label: "USER" },
  { value: "SUPER_ADMIN", label: "SUPER_ADMIN" },
]

//export const DEFAULT_APP_ID = "5cf524a4-ba08-473e-ac73-99be98a0d693"
export const DEFAULT_APP_ID = ""

export const MUSC_USER_STATUS = {
  process: "Processing...",
  active: "Active",
}

export const MUSC_USER_ROLES = {
  USER: "USER",
  IT: "IT",
}

//export const MIGRATE_USER = "marie.musc@consensus.com"
export const MIGRATE_USER =
  process.env.REACT_APP_ENV === "production"
    ? "marie.musc@consensus.com"
    : "musc_it1@yopmail.com"

export const PERSONAL_FAX =
  process.env.REACT_APP_ENV === "production" ? "18432716148" : "17142760685"

export const COMPOSE_REPLACE_FAX =
  process.env.REACT_APP_ENV === "production"
    ? {
        oldFaxNumber: "18432782347",
        newFaxNumber: "18437922504",
      }
    : {
        oldFaxNumber: "17142760646",
        newFaxNumber: "11111111111",
      }
